var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#606060;}")),React.createElement("g",{"transform":"translate(-1628.802 -2169.194)","key":1},React.createElement("path",{"className":"a","d":"M1687.962,2188.833h-17.431V2171.4a2.208,2.208,0,0,0-2.208-2.208H1650.65a2.207,2.207,0,0,0-2.208,2.208v17.431h-17.431a2.209,2.209,0,0,0-2.209,2.208v17.673a2.208,2.208,0,0,0,2.209,2.208h17.431v17.432a2.208,2.208,0,0,0,2.208,2.208h17.673a2.209,2.209,0,0,0,2.208-2.208v-17.432h17.431a2.207,2.207,0,0,0,2.208-2.208v-17.673A2.208,2.208,0,0,0,1687.962,2188.833Z"}))]);
}

Cross.defaultProps = {"width":"61.368","height":"61.368","viewBox":"0 0 61.368 61.368"};

module.exports = Cross;

Cross.default = Cross;
